module.exports = __webpack_public_path__ + "img/pic21.2b361c5e.png";